export const CONCURRENCY_GROUP_SEARCH_DEBOUNCE_MS = 300;

export const CONCURRENCY_GROUP_LOCALE = "pt-BR";

export const CONCURRENCY_GROUP_TRIGGER_ID = "mc-concurrency-group";

export const CONCURRENCY_GROUP_ITEM_PREFIX = {
  GROUP: "group:",
  CREATE: "create:",
} as const;

export const ConcurrencyGroupListState = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  READY: "READY",
} as const;

export type ConcurrencyGroupListState =
  (typeof ConcurrencyGroupListState)[keyof typeof ConcurrencyGroupListState];
